import { DOCUMENT, inject, Injectable } from '@angular/core';
import { map, Observable, switchMap, tap, throwError } from 'rxjs';

import {
  CombineSurveyTrafficReportParams,
  ProjectManager,
  SurveyTransactionStatus,
  TemplateFolder,
} from '@ps/survey-utils';

import {
  GetTemplatesParams,
  SurveyReferenceApi,
} from '../../api/survey-reference/survey-reference.api';
import { DownloadableBlob } from '@ps/utils';

@Injectable({ providedIn: 'root' })
export class SurveyReferenceService {
  private readonly _document = inject(DOCUMENT);
  private readonly _api = inject(SurveyReferenceApi);

  public getBuyerManagers(companyId: number): Observable<ProjectManager[]> {
    return this._api.getBuyerManagers(companyId);
  }

  public getOperatorManagers(): Observable<ProjectManager[]> {
    return this._api.getOperatorManagers();
  }

  public getTemplates(
    params: GetTemplatesParams,
  ): Observable<TemplateFolder[]> {
    return this._api.getTemplates(params);
  }

  public getTransactionStatuses(): Observable<SurveyTransactionStatus[]> {
    return this._api.getTransactionStatuses();
  }

  public getCombinedSurveyTrafficReport(
    data: CombineSurveyTrafficReportParams,
  ): Observable<boolean> {
    return this._api.getCombinedSurveyTrafficReport(data).pipe(
      switchMap((res) => {
        if (res.apiStatus !== 'success') {
          return throwError(
            () =>
              new Error('Failed to download combined survey traffic report.'),
          );
        }
        return this._api.downloadCSTReport(res.fileName).pipe(
          tap((blob) =>
            new DownloadableBlob(blob, res.fileName, this._document).download(),
          ),
          map(() => true),
        );
      }),
    );
  }
}
